
/*
*###############################################################################
*Module Name                   : SearchColumn.js                               #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               :  Dinisuru Balasuriya                          #
*Date                          : Friday, August 12th 2021, 12:02:19 pm         #
*Copyright (c) 2021 myPOS Software Solution (pvt Ltd.)                         #
*###############################################################################
*/


const loadPopupSearchPay = async (menuCode, strSearchCtrl) => {
    let arCusCol = []
    let searchBy = ""
    if (menuCode == null || menuCode == undefined || menuCode == "") return arCusCol


    let SearchSummary = await GetSearchTable(menuCode, strSearchCtrl)
    SearchSummary.map(dr => {
        if (dr.strDispCol != null) {
            let CustomerColumns = dr.strDispCol
            let CustomerColumnsSearchCol = dr.strSearchCol
            searchBy = dr.strSearchBy
            let AlignmentColumns = dr.strAlignment
            let DispCol = CustomerColumns.split(",")
            let SearchCol = CustomerColumnsSearchCol.split(",")
            let Alignment = AlignmentColumns.split(",")

            for (let i = 0; i < DispCol.length; i++) {
                arCusCol.push({
                    field: String(SearchCol[i]).trim(),
                    title: String(DispCol[i]).trim(),
                    align: String(Alignment[i]).trim() == null || String(Alignment[i]).trim() == "" || String(Alignment[i]).trim() == undefined || Alignment[i] == undefined ? "center" : String(Alignment[i]).trim(),
                    cellStyle: {
                        whiteSpace: "nowrap",
                    }
                })
            }

        }
    }
    )
    return { arCusCol, searchBy }
}


const GetSearchTable = async (id, strSearchCtrl) => {
    const ApiURL = window.Links.ApiURL
    const authToken = localStorage.getItem("authToken")
    var myHeaders = new Headers()
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${authToken}`);
    var data = []
    var requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
    }
    await fetch(`${ApiURL}myReport/searchTable/${id}/${strSearchCtrl}`, requestOptions)
        .then(response => response.json())
        .then(result => {
            data = result.data
        })
        .catch(error => console.log("error", error))
    return data
}





const loadPopupSearchPayHeadOffice = async (menuCode, strSearchCtrl) => {
    let arCusCol = []

    if (menuCode == null || menuCode == undefined || menuCode == "") return arCusCol


    let SearchSummary = await GetSearchTableHeadOffice(menuCode, strSearchCtrl)
    SearchSummary.map(dr => {
        if (dr.strDispCol != null) {
            let CustomerColumns = dr.strDispCol
            let CustomerColumnsSearchCol = dr.strSearchCol
            let AlignmentColumns = dr.strAlignment
            let DispCol = CustomerColumns.split(",")
            let SearchCol = CustomerColumnsSearchCol.split(",")
            let Alignment = AlignmentColumns.split(",")

            for (let i = 0; i < DispCol.length; i++) {
                arCusCol.push({
                    field: String(SearchCol[i]).trim(),
                    title: String(DispCol[i]).trim(),
                    align: String(Alignment[i]).trim() == null || String(Alignment[i]).trim() == "" || String(Alignment[i]).trim() == undefined || Alignment[i] == undefined ? "center" : String(Alignment[i]).trim(),
                    cellStyle: {
                        whiteSpace: "nowrap",
                    }
                })
            }

        }
    }
    )
    return arCusCol
}


const GetSearchTableHeadOffice = async (id, strSearchCtrl) => {
    const ApiURL = window.Links.ApiURL
    const authToken = localStorage.getItem("authToken")
    var myHeaders = new Headers()
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${authToken}`);
    var data = []
    var requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
    }
    await fetch(`${ApiURL}myReport/searchTable/HeadOffice/${id}/${strSearchCtrl}`, requestOptions)
        .then(response => response.json())
        .then(result => {
            data = result.data
        })
        .catch(error => console.log("error", error))
    return data
}




export { loadPopupSearchPay, GetSearchTable, loadPopupSearchPayHeadOffice }